import { useNavigate } from "react-router-dom";
import {
  NFPageContainer,
  NFPageError,
  NFPageLogo,
  NFPageLogoColor,
  NFPageText,
} from "./NotFoundPageStyles.styled";
import useAuth from "../../Redux/useAuth";
import { useLanguageContext } from "../Languages/Langs/LanguageContext";

export const NotFoundPage = () => {
  const { t } = useLanguageContext();
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleClick = () => {
    if (user && user.name) {
      navigate(`/home-page/${user.name.toLowerCase()}`);
    } else {
      navigate("/sign-in");
    }
  };

  return (
    <>
      <NFPageContainer>
        <NFPageLogo onClick={handleClick}>
          Safe<NFPageLogoColor>Tasker</NFPageLogoColor>
        </NFPageLogo>
        <NFPageText>{t("privateTraslate.NotFoundPage.Title")} 🥺</NFPageText>
        <NFPageError>
          {t("privateTraslate.NotFoundPage.DescibeTextPage")}
        </NFPageError>
      </NFPageContainer>
    </>
  );
};
